module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/8ec0872d761c3de6c6a3acd66b559ee4.svg";